<div class="breadcrumb-container">
  <ds-breadcrumbs id="usersCartEditBreadcrumbs" [breadcrumbs]="breadcrumbs" separatorType="slash"
    [collapsable]="false" [iconStyle]="isMobile ? 'material-icons-outlined' : null">
  </ds-breadcrumbs>
</div>

@if (!isMobile) {
  <div class="header-container">
    <div class="header-title">
       <div class="title-container">
        <typography id="usersCartEditTitle" variant="mat-headline-4" weight="bold">
          {{ appStrings.menu_Users }} - {{ appStrings.button_editCart }}
        </typography>
        <typography variant="mat-headline-4" weight="bold">|</typography>
        <typography variant="mat-headline-4" weight="bold">
          {{ user.FirstName }} {{ user.LastName }}
        </typography>
      </div>
      <ds-chip id="email" variant="filled" size="medium">{{ user.Email }}</ds-chip>
    </div>
    <div class="header-buttons">
      <ng-container *ngTemplateOutlet="deleteCartButton"></ng-container>
      <ng-container *ngTemplateOutlet="backButtonTemplate"></ng-container>
    </div>
  </div>
}

@if (user) {
  <div class="b2b-edit-cart-container">
    @if (isMobile) {
      <div class="user-info">
        <typography variant="mat-headline-4" weight="bold">
          {{ user.FirstName }} {{ user.LastName }}
        </typography>
        <div class="email-cart-info">
          <typography variant="mat-body-1" weight="regular">
            {{ user.Email }}
          </typography>
          @if (user.itemsInCart !== undefined) {
            <span>|</span>
          }
          @if (user.itemsInCart !== undefined) {
            <typography variant="mat-body-1" weight="regular">
              {{ user.itemsInCart }} {{ appStrings.b2bCart_itemsInCart }}
            </typography>
          }
        </div>
      </div>
    }

    <div class="cart-content">
      @if (!isMobile) {
        <ds-paper elevation="elevation_none" borderRadius="radius_S" outline="outlined" insidePaddingTop="top-spacing_L"
          insidePaddingBottom="bottom-spacing_L" insidePaddingLeft="left-spacing_XL" insidePaddingRight="right-spacing_XL">
          <app-b2b-user-cart [user]="user" [userIndex]="0" [editMode]="true" [bpNumber]="bpNumber" [countryCodeId]="countryCodeId"></app-b2b-user-cart>
        </ds-paper>
      }
      @if (isMobile) {
        <div>
          <app-b2b-user-cart [user]="user" [userIndex]="0" [editMode]="true" [bpNumber]="bpNumber" [countryCodeId]="countryCodeId"></app-b2b-user-cart>
        </div>
      }
    </div>
  </div>
}

<ng-template #backButtonTemplate>
  <ds-button id="backButton" size="large" type="secondary"
    variant="label-only" [label]="appStrings.button_close" (onClick)="goBack()">
  </ds-button>
</ng-template>

<ng-template #deleteCartButton>
  <ds-button id="deleteCartButton" size="large" type="secondary" variant="label-only"
    [label]="appStrings.button_delete" (onClick)="showDeleteCartDialog()">
  </ds-button>
</ng-template>

<ds-dialog
  id="deleteCartDialog"
  [title]="appStrings.b2bCart_deleteCartDialogTitle"
  [description]="appStrings.b2bCart_deleteCartDialogDescription"
  [actionButtons]="deleteDialogButtons"
  [open]="deleteCartDialogOpen$">
</ds-dialog>

@if (isMobile) {
  <div class="mobile-sticky-footer">
    <ds-button id="deleteCartButtonMobile" size="medium" type="tertiary"
      variant="label-only" [label]="appStrings.button_delete" (onClick)="showDeleteCartDialog()">
    </ds-button>
    <ds-button id="closeButtonMobile" size="medium" type="secondary"
      variant="label-only" [label]="appStrings.button_close" (onClick)="goBack()">
    </ds-button>
    <ds-button id="addItemButtonMobile" size="medium" type="primary"
      variant="label-only" [label]="appStrings.button_addItem" (onClick)="addItem()">
    </ds-button>
  </div>
}

@if (loading) {
  <div class="overlay full">
    <ds-progress-spinner id="deleteCartLoader"></ds-progress-spinner>
    <typography id="deletingMessage" class="text-center">{{appStrings.pleaseWait}}</typography>
  </div>
}